import { DateTimePicker, DateTimePickerAndroid } from '@react-native-community/datetimepicker';
import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import { EvilIcons, Entypo } from '@expo/vector-icons'; 
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import css from './Style'
import { TouchableOpacity } from 'react-native-gesture-handler';

const MyDatePicker = (props) => {
    const [date, setDate] = React.useState(new Date());
    const [mode, setMode] = React.useState('date');
    const [show, setShow] = React.useState(false);

    const [dateString, setDateString] = React.useState(props.placeholder??'Date');

    const padLeft = (num) => {
        if(num < 10)
            return '0'+num;
        return num;
    }

    const onChange = (event, selectedDate, mode) => {
        if(event.type == 'set'){ //dismissed = canceled, set = modified
            const currentDate = selectedDate;
            setShow(false);
            setDate(currentDate);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            setDateString(padLeft(currentDate.getDate() + ' ' + months[currentDate.getMonth()] + ', ' + currentDate.getFullYear().toString().slice(2)));
            props.onChange(currentDate);
        }
    };

    const showMode = (currentMode) => {
        if (Platform.OS === 'android') {
            setShow(false);
            DateTimePickerAndroid.open({
                value: date,
                onChange,
                mode: currentMode,
                is24Hour: true,
            });
            // for iOS, add a button that closes the picker
        }
        setMode(currentMode);
    };

    const showDatepicker = () => {
        // setShow(true);
        showMode('date');
    };
    
    return (
        <View style={styles.container}>
            <View style={styles.date}>
                <TouchableOpacity onPress={showDatepicker}>
                    <MyTextInput icon="date" editable={false} value={''} style={{color: '#b9bab7', fontSize: props.small?8:10}}/>
                    {
                        dateString.includes('\n')?
                        <MyText onPress={showDatepicker} style={styles.multiLinePlaceholder}>
                            {dateString}
                        </MyText>
                        :
                        <MyText onPress={showDatepicker} style={styles.placeholder}>
                            {dateString}
                        </MyText>
                    }
                </TouchableOpacity>
            </View>
            {show && (
                <DateTimePicker
                testID="dateTimePicker"
                value={date}
                mode={mode}
                is24Hour={true}
                onChange={onChange}
                timeZoneOffsetInMinutes={0}
                />
            )}
        </View>
    );
}
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        display: 'flex',
        width: '100%'
    },
    date: {
        flex: 1,
        marginRight: 2,
        position: 'relative',
        overflow: 'hidden'
    },
    placeholder: {
        position: 'absolute',
        left: 33,
        fontSize: 10,
        top:8,
        color: '#474747',
        opacity: 0.5
    },
    multiLinePlaceholder: {
        position: 'absolute',
        left: 33,
        fontSize: 10,
        top: 2,
        color: '#474747',
        opacity: 0.5
    }
})
export default MyDatePicker